// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"lH","hidden":"lI"};